import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {SettingService} from './setting.service';
import {LoginStorageService} from './login-storage.service';
import {HttpClient} from '@angular/common/http';

@Injectable()
export class AuthenticationService {

  constructor(private http: HttpClient,
              private router: Router,
              private settings: SettingService,
              private loginStorageService: LoginStorageService) {

  }

  login() {

  }

  callback() {

  }


  logout() {

    const self = this;
    sessionStorage.clear();
    self.loginStorageService.clear();

  }

  get accessToken() {
    const jwt = this.loginStorageService.getJwt();
    if (jwt) {
      return jwt.access_token;
    }
    return null;
  }


  get isAuthenticated(): boolean {
    const jwt = this.loginStorageService.getJwt();

    return jwt;
  }


  get currentUser() {
    const user = this.loginStorageService.getUser();
    return user;
  }

}
